import { TransactionStatus, TransactionType } from '@profile/src/models';
export const formatStatus = status => {
  switch (status) {
    case TransactionStatus.SUCCESS:
    case TransactionStatus.COMFIRM_SUCCESS:
      return {
        displayName: 'Completed',
        style: 'completed'
      };

    case TransactionStatus.WAITING:
    case TransactionStatus.NEW:
    case TransactionStatus.PENDING:
    case TransactionStatus.REFUND_PENDING:
      return {
        displayName: 'Processing',
        style: 'processing'
      };

    case TransactionStatus.ADMIN_REVERT:
    case TransactionStatus.REJECTED:
    case TransactionStatus.ERROR:
    case TransactionStatus.FAILED:
    case TransactionStatus.REFUND_ERROR:
    case TransactionStatus.COMFIRM_ERROR:
      return {
        displayName: 'Cancelled',
        style: 'cancelled'
      };

    case TransactionStatus.REFUND_SUCCESS:
      return {
        displayName: 'Refunded',
        style: 'refunded'
      };

    default:
      return undefined;
  }
};
export const formatType = status => {
  switch (status) {
    case TransactionType.CLAIM:
      return 'Claim';

    default:
      return 'Deposit';
  }
};